import axios from 'axios';
import resolvePath from 'utils/resolvePath';
// Action
const CLEAR = 'pickUp/clear';
const GET_PICKUP_TAGS_REQUEST = 'pickUp/getPickUpTagsRequest';
const GET_PICKUP_TAGS_SUCCESS = 'pickUp/getPickUpTagsSuccess';
const GET_PICKUP_TAGS_FAILURE = 'pickUp/getPickUpTagsFailure';
const GET_PICKUP_TAG_USERS_REQUEST = 'pickUp/getPickUpTagUsersRequest';
const GET_PICKUP_TAG_USERS_SUCCESS = 'pickUp/getPickUpTagUsersSuccess';
const GET_PICKUP_TAG_USERS_FAILURE = 'pickUp/getPickUpTagUsersFailure';
// Action Creator
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getPickUpTagsRequest = () => {
    return {
        type: GET_PICKUP_TAGS_REQUEST,
    };
};
export const getPickUpTagsSuccess = (pickUpTags) => {
    return {
        payload: {
            pickUpTags,
        },
        type: GET_PICKUP_TAGS_SUCCESS,
    };
};
export const getPickUpTagsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_PICKUP_TAGS_FAILURE,
    };
};
export const getPickUpTags = (authToken) => {
    return (dispatch) => {
        dispatch(getPickUpTagsRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('pickup_tags'), config)
            .then((response) => dispatch(getPickUpTagsSuccess(response.data)))
            .catch((error) => {
            dispatch(getPickUpTagsFailure(error));
            throw error;
        });
    };
};
export const getPickUpTagUsersRequest = () => {
    return {
        type: GET_PICKUP_TAG_USERS_REQUEST,
    };
};
export const getPickUpTagUsersSuccess = (pickUpTagUsers) => {
    return {
        payload: {
            pickUpTagUsers,
        },
        type: GET_PICKUP_TAG_USERS_SUCCESS,
    };
};
export const getPickUpTagUsersFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_PICKUP_TAG_USERS_FAILURE,
    };
};
export const getPickUpTagUsers = (authToken, id, page) => {
    return (dispatch) => {
        dispatch(getPickUpTagUsersRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: {
                page: page + 1,
                per_page: 10,
            },
        };
        return axios
            .get(`${resolvePath.api(`pickup_tags/${id}`)}`, config)
            .then((response) => dispatch(getPickUpTagUsersSuccess(response.data)))
            .catch((error) => {
            dispatch(getPickUpTagUsersFailure(error));
            throw error;
        });
    };
};
const initialPickUpTagUsersState = {
    tag: null,
    users: [],
};
const initialState = {
    error: null,
    pickUpTags: [],
    pickUpTagUsers: initialPickUpTagUsersState,
    page: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { pickUpTagUsers: initialPickUpTagUsersState, page: 0 });
        }
        case GET_PICKUP_TAGS_REQUEST: {
            return Object.assign({}, state);
        }
        case GET_PICKUP_TAGS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { pickUpTags: action.payload.pickUpTags });
        }
        case GET_PICKUP_TAGS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        case GET_PICKUP_TAG_USERS_REQUEST: {
            return Object.assign({}, state);
        }
        case GET_PICKUP_TAG_USERS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { pickUpTagUsers: {
                    tag: action.payload.pickUpTagUsers.tag,
                    users: [...state.pickUpTagUsers.users, ...action.payload.pickUpTagUsers.users],
                }, page: state.page + 1 });
        }
        case GET_PICKUP_TAG_USERS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        default: {
            return state;
        }
    }
};
